import styled, { useTheme } from 'styled-components';
import { Heading5Text, ParagraphSmallText } from '../../components/Texts';
import Button from '../../components/Button';
import { useNavigate } from 'react-router-dom';
import { usePrivy } from '@privy-io/react-auth';
import useCustomLogin from '../../hooks/useCustomLogin';
import { PHONE_MEDIA_QUERY, useMediaQuery } from '../../common/responsive';
import SolanaIcon from '../../assets/icons/solana.svg?react';

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  position: relative;
  @media ${PHONE_MEDIA_QUERY} {
    margin-top: 40px;
  }
`;

const AbsoluteContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  width: 100%;
  height: 100%;
  gap: 24px;
  flex-direction: column;
  @media ${PHONE_MEDIA_QUERY} {
    gap: 12px;
  }
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  @media ${PHONE_MEDIA_QUERY} {
    gap: 0px;
  }
`;

const FirstBar = styled.div`
  width: 100%;
  height: 104px;
  background-color: ${({ theme }) => theme.background.light};
  border-radius: 16px;
`;

const SecondBar = styled(FirstBar)`
  height: 75px;
`;

const ThirdBar = styled(FirstBar)`
  height: 30px;
`;

const MobileFirstBar = styled.div`
  width: 100%;
  padding: 12px;
  border: 1px solid ${({ theme }) => theme.border.secondary};
  border-radius: 8px;
  display: flex;
  gap: 12px;
  background-color: ${({ theme }) => theme.background.primary};
  z-index: 5;
`;

const MobileSecondBar = styled(MobileFirstBar)`
  height: 64px;
  position: absolute;
  top: -12px;
  width: 95%;
  left: 2.5%;
  right: 2.5%;
  z-index: 2;
  opacity: 0.6;
`;

const MobileThirdBar = styled(MobileFirstBar)`
  height: 64px;
  position: absolute;
  top: -24px;
  width: 90%;
  left: 5%;
  right: 5%;
  z-index: 1;
  opacity: 0.3;
`;

const TokenLogoContainer = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 100%;
  background-color: ${({ theme }) => theme.background.secondPrimary};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Bar = styled.div`
  width: 100%;
  height: 8px;
  background-color: ${({ theme }) => theme.background.secondPrimary};
  border-radius: 8px;
`;

const PortfolioEmptyState = () => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery(PHONE_MEDIA_QUERY);
  const theme = useTheme();
  const { authenticated } = usePrivy();
  const { login } = useCustomLogin();

  if (isMobile) {
    return (
      <Container>
        <MobileFirstBar>
          <TokenLogoContainer>
            <SolanaIcon
              width={24}
              height={24}
              color={theme.background.primary}
            />
          </TokenLogoContainer>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              justifyContent: 'center',
              gap: '4px',
              width: '30%',
            }}
          >
            <Bar style={{ width: '50%' }} />
            <Bar />
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '20px',
              marginLeft: 'auto',
              width: '30%',
            }}
          >
            <Bar style={{ width: '70%' }} />
            <Bar style={{ width: '30%' }} />
          </div>
        </MobileFirstBar>
        <MobileSecondBar></MobileSecondBar>
        <MobileThirdBar></MobileThirdBar>
        <AbsoluteContainer style={{ position: 'relative' }}>
          {authenticated ? (
            <>
              <TextContainer>
                <Heading5Text style={{ color: theme.text.title }}>
                  Your portfolio is empty
                </Heading5Text>
                <ParagraphSmallText style={{ color: theme.text.secondary }}>
                  Start discovering tokens to grow your collection.
                </ParagraphSmallText>
              </TextContainer>
              <Button
                style={{ height: '40px' }}
                variant={'secondary'}
                onClick={() => {
                  navigate('/app/discover');
                }}
              >
                DISCOVER TOKENS
              </Button>
            </>
          ) : (
            <>
              <TextContainer>
                <Heading5Text>Login to view your assets</Heading5Text>
              </TextContainer>
              <Button
                onClick={() => {
                  login();
                }}
              >
                Login
              </Button>
            </>
          )}
        </AbsoluteContainer>
      </Container>
    );
  }

  return (
    <Container>
      <FirstBar />
      <SecondBar />
      <ThirdBar />
      <AbsoluteContainer>
        {authenticated ? (
          <>
            <TextContainer>
              <Heading5Text style={{ color: theme.text.title }}>
                Your portfolio is empty
              </Heading5Text>
              <ParagraphSmallText style={{ color: theme.text.secondary }}>
                Start discovering tokens to grow your collection.
              </ParagraphSmallText>
            </TextContainer>
            <Button
              variant={'secondary'}
              onClick={() => {
                navigate('/app/discover');
              }}
            >
              DISCOVER TOKENS
            </Button>
          </>
        ) : (
          <>
            <TextContainer>
              <Heading5Text>Login to view your assets</Heading5Text>
            </TextContainer>
            <Button
              onClick={() => {
                login();
              }}
            >
              Login
            </Button>
          </>
        )}
      </AbsoluteContainer>
    </Container>
  );
};

export default PortfolioEmptyState;
